
export default {
    path: "/planos",
    name: "Plans",
    component: () => import("@/presentation/views/Plans/Plans.vue"),
    redirect: { name: "PlansList" },
    meta: { requiresAuth: true, allowPermission: 'plans:list' },
    list: {
        path: "lista",
        name: "PlansList",
        component: () =>
            import("@/presentation/views/Plans/PlansList/PlansList.vue"),
    },
    detail: {
        path: "detalhes/:id",
        name: "PlanDetail",
        component: () =>
            import("@/presentation/views/Plans/PlanDetail/PlanDetail.vue"),
    },
    add: {
        path: "adicionar",
        name: "AddPlan",
        component: () => import("@/presentation/views/Plans/AddPlan/AddPlan.vue"),
    },
} as const